/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    affiliates: {
        menu: {
            index: 'Affiliates',
            create: 'New',
            list: 'Affiliates'
        },
        table_titles: {
            id: 'ID',
            affiliate: 'Affiliate\'s name',
            rebit_account: 'Rebit Account',
            commission: 'Commission (%)',
            contracted_at: 'Contract date',
            setting: 'Edit / Delete',
        },
        earnings: {
            index: 'Earnings',
            month: 'Month',
            total_usdt: 'Total (USDT)',
            commission_usdt: 'Commission (USDT)',
            pay: 'Pay',
            settle_commission: 'Settle Commission'
        },
        edit: 'Edit an affiliate'
    }
}
